import { jsx as _jsx } from "react/jsx-runtime";
const Field = ({
  children,
  ['data-test-id']: dataTestId
}) => /*#__PURE__*/_jsx("div", {
  className: "m-bottom-1",
  "data-test-id": dataTestId,
  children: children || null
});
export default Field;